import User from "@/config/user";

export const UserInfo = "UserInfo";
export const ClearUserinfo = "ClearUserinfo";

export function userInfo(res: any) {
  return {
    type: UserInfo,
    rs: res
  };
}

export function clearUserinfo() {
  return { type: ClearUserinfo };
}

export function getAccountInfo() {
  return (dispatch: any) => {
    return User.getAccountInfo().then((res: any) =>
      dispatch(userInfo(res ?? {}))
    );
  };
}

export function getUserAccountById(subreddit: any) {
  return (dispatch: any) => {
    return User.getUserAccountById(subreddit).then((res: any) =>
      dispatch(userInfo(res ?? {}))
    );
  };
}